<div class="modal-wrapper">
    <strong class="modal-title so-title">{{ data.title }}</strong>
    <div class="modal-body">
        <div class="modal-image" *ngIf="data.image">
        <img [src]="data.image" alt="announcement-img" />
        </div>

        <div class="modal-message so-text-2">
        <p>{{ data.message }}</p>
        </div>
    </div>

  <div class="modal-footer">
    <app-button 
      [text]="data.confirmText" 
      [svg]="'mdi-check-circle-outline'" 
      [type]="'button'"
      [iconAlignment]="'right'" 
      [injection]="{ label: 'pt-2' }" 
      [width]="'100%'" 
      [colorIcon]="'--so-secondary'" 
      [applyChanges]="true"
      (click)="confirm()"
    ></app-button>
  </div>
</div>